import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
// Benign browser warnings that fire constantly on resize/drag-heavy UI (tables,
// kanban) and have no actionable stack trace — filtered to stop draining quota.
const ignoreErrors = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
];
if (window.location.hostname.match('dev')) {
    Sentry.init({
        dsn: 'https://3e85055730e34eefbc22db2ebae12bd1@sentry.io/1829578',
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
        environment: 'development',
        ignoreErrors,
    });
}
else {
    if (window.location.hostname.match('app') ||
        window.location.hostname.match('test'))
        Sentry.init({
            dsn: 'https://3e85055730e34eefbc22db2ebae12bd1@sentry.io/1829578',
            integrations: [new Integrations.Vue({ Vue, attachProps: true })],
            environment: 'production',
            ignoreErrors,
        });
}
